var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M15 8h.01M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" }),
      createElementVNode("path", { d: "m3 16l5-5c.928-.893 2.072-.893 3 0l5 5" }),
      createElementVNode("path", { d: "m14 14l1-1c.928-.893 2.072-.893 3 0l3 3" })
    ], -1)
  ]));
}
__name(render, "render");
const photo = markRaw({ name: "tabler-photo", render });
export {
  photo as default
};
//# sourceMappingURL=photo.js.map
